import { render, staticRenderFns } from "./DialogPegaEmail.vue?vue&type=template&id=a0dccc9e&scoped=true&"
import script from "./DialogPegaEmail.vue?vue&type=script&lang=js&"
export * from "./DialogPegaEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0dccc9e",
  null
  
)

export default component.exports